<template lang="html">
  <div class="home">
    <p v-for="(text, index) in texts" v-html="$t(text)" :key="index"></p>
  </div>
</template>

<script>
export default {
  name: 'Home',
  computed: {
    texts() {
      return this.$i18n.t('meta.about.entries');
    },
  },
};
</script>

<style lang="scss">
.home {
  p {
    margin-bottom: ms(1);
  }
  @media screen {
    @include respond-to('tablet') {
      @include xCols(2)
    }
  }
}
</style>
